import p1 from "../../assets/images/p-1.png";
import * as Yup from "yup";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import { Formik, Form, FormikContext, setIn } from "formik";
import { useParams } from "react-router-dom";
import { ReactMultiSelect, TextInput, FileInput, TextArea, NumberInput, } from "../../components/utilityComponent/form-fields";
import { toast } from "react-toastify"
import Cookies from 'js-cookie'
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ckConfig from "../../config/ck-config";

const PageSchema = Yup.object({
    title: Yup.string()
        .trim()
        .min(2, "Minimum of two keywords required")
        .max(50, "Maximum of 50 keywords allowed")
        .required("Page title is required"),
    subTitle: Yup.string()
        .trim()
        .min(2, "Minimum of two keywords required")
        .max(50, "Maximum of 50 keywords allowed")
        .required("Page subtitle is required"),
    slug: Yup.string().trim().required("Page slug is required"),
    pageContent: Yup.string().trim().required("Page content is required")
});


const NewPageForm = () => {

    const history = useHistory();
    const token = Cookies.get('token');
    const [page, setPage] = useState();
    const { pageId } = useParams();
    const [initialValues, setInitialValues] = useState({
        title: "",
        subTitle: "",
        slug: "",
        headerShow: "false",
        footerShow: "false",
        pageContent: ""
    });
    const [editorData, setEditorData] = useState();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false)
    const [color, setColor] = useState("#ffffff");
    const [valuesLoaded, setValuesLoaded] = useState(false);

    const override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    useEffect(() => {
        // let product = useSelector((state) => { return state.productDetails.listing; })

        if (pageId)
            fetchPage(pageId)
    }, [])

    useEffect(() => {
        if (page) {
            console.log("page set!!!")
            let data = { ...page }
            delete data._id
            setInitialValues({ ...page }); // 
            console.log("page title: ", page.title);
        }
    }, [page])

    useEffect(() => {
        if (!valuesLoaded && pageId && page)
            setValuesLoaded(true)
        else if (!pageId)
            setValuesLoaded(true);
    }, [initialValues])

    /** State */
    const fetchPage = async (id) => {
        const response = await axios.request({
            headers: {
                'Content-Type': 'application/json',
                'Authorization': Cookies.get('token')
            },
            method: 'get',
            url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-page-by-id?id=${id}`
        });
        setPage(response.data);
    }

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        if (name === "title") {
            let text = value;
            text = text.toLowerCase()
                .replace(/ /g, '-')
                .replace(/[^\w-]+/g, '');
            // if (text[text.length - 2] === '-' && text[text.length - 1] === '-')
            //     text = text.slice(0, -1);

            setInitialValues({ ...initialValues, slug: text, [name]: value })
        }
        else
            setInitialValues({ ...initialValues, [name]: value });
    };

    const onSubmit = async (values) => {
        setLoading(true);
        setDisable(true);
        if (pageId) {
            const callback = async () => {
                setLoading(false);
                setDisable(false);
                history.push("/cms-pages");
            };
            const response = await axios.request({
                data: { id: pageId, title: values.title.trim(), subTitle: values.subTitle.trim(), slug: values.slug, headerShow: values.headerShow, footerShow: values.footerShow, pageContent: values.pageContent },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'put',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/edit-page`
            })
            if (response.data.success)
                toast.success(response.data.message)
            else
                toast.error("Something went wrong")
            callback()
            console.log("response for editing page: ", response.data);

        } else {
            const callback = async () => {
                setLoading(false);
                setDisable(false);
                history.push("/cms-pages");
            };
            const response = await axios.request({
                data: { title: values.title, subTitle: values.subTitle, slug: values.slug, headerShow: values.headerShow, footerShow: values.footerShow, pageContent: values.pageContent },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': Cookies.get('token')
                },
                method: 'post',
                url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/add-page`
            })
            if (response.data.success)
                toast.success(response.data.message)
            else
                toast.error("Something went wrong")
            callback()
            console.log("response for adding page: ", response.data);
        }
    };

    const handleOnEditorChange = (event, editor) => {
        const data = editor.getData();
        if (valuesLoaded)
            setInitialValues({ ...initialValues, pageContent: data })
        // console.log({ event, editor, data });
    }

    return (

        <>
            <div className="dashContentHeader px-5 mb-3 row">
                <h5 className="dashHeading mb-0 fontfammedium p-0">
                    {pageId ? "Edit Page" : "Add New Page"}
                </h5>

            </div>
            <div className="row dashboardCardRow px-5">
                <div className="col-lg-8 bg-white mt-5 shadow">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={PageSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ errors, values }) => (
                            console.log("Errors : ", errors),
                            (
                                <Form className="mg-login new-product mt-4 px-3">
                                    <div className="row mb-0">
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Page Title"
                                                name="title"
                                                id="title"
                                                type="text"
                                                placeholder="Enter page title here"
                                                className="form-control "
                                                onChange={handleOnChange}
                                                isRequired
                                                errors={errors}
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Page SubTitle"
                                                name="subTitle"
                                                id="subTitle"
                                                type="text"
                                                placeholder="Enter page subtitle here"
                                                className="form-control "
                                                onChange={handleOnChange}
                                                isRequired
                                                errors={errors}
                                            />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <TextInput
                                                label="Page Slug"
                                                name="slug"
                                                id="slug"
                                                type="text"
                                                placeholder="i.e about-us"
                                                className="form-control "
                                                // onChange={handleOnChange}
                                                // isRequired
                                                // errors={errors}
                                                disabled
                                            />
                                        </div>
                                        <div className="col-md-8 mb-4 form-group d-flex flex-wrap justify-content-between" >
                                            <div>
                                                <label className="d-block">Show in Header Links</label>
                                                <div style={{ display: "flex" }}>
                                                    <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                                        <input
                                                            className="mr-1"
                                                            type="radio"
                                                            name="headerShow"
                                                            value={true}
                                                            onClick={handleOnChange}
                                                            checked={initialValues.headerShow === "true" ? true : false}
                                                        />
                                                        <label > Yes</label>
                                                    </div>
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <input
                                                            className="mr-1"
                                                            type="radio"
                                                            name="headerShow"
                                                            value={false}
                                                            onClick={handleOnChange}
                                                            checked={initialValues.headerShow !== "true" ? true : false}
                                                        />
                                                        <label> No</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <label className="d-block">Show in Footer Links</label>
                                                <div style={{ display: "flex" }}>
                                                    <div className="mr-3" style={{ display: "flex", alignItems: "center" }}>
                                                        <input
                                                            className="mr-1"
                                                            type="radio"
                                                            name="footerShow"
                                                            value={true}
                                                            onClick={handleOnChange}
                                                            checked={initialValues.footerShow === "true" ? true : false}
                                                        />
                                                        <label > Yes</label>
                                                    </div>
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <input
                                                            className="mr-1"
                                                            type="radio"
                                                            name="footerShow"
                                                            value={false}
                                                            onClick={handleOnChange}
                                                            checked={initialValues.footerShow !== "true" ? true : false}
                                                        />
                                                        <label> No</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-12">
                                            <hr className="w-100 mb-4" />
                                        </div>
                                        <div className="col-md-12 mb-4 form-group">
                                            <label htmlFor="pageContent">Page Content</label>
                                            <CKEditor
                                                id="pageContent"
                                                editor={ClassicEditor}
                                                config={ckConfig.config}
                                                name="pageContent"
                                                data={initialValues.pageContent}
                                                onReady={editor => {
                                                    // You can store the "editor" and use when it is needed.
                                                    console.log('Editor is ready to use!', editor);
                                                }}
                                                onChange={handleOnEditorChange}
                                                onBlur={(event, editor) => {
                                                    // console.log('Blur.', editor);
                                                }}
                                                onFocus={(event, editor) => {
                                                    // console.log('Focus.', editor);
                                                }}
                                            />
                                            <div className="invalid-feedback-ckEditor">
                                                {errors["pageContent"]}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between mb-5">
                                        <button className="mb-5 sub-button mt-4 px-4" onClick={() => history.push("/cms-pages")}>Back</button>
                                        <button
                                            type="submit"
                                            disabled={disable}
                                            className="mb-5 sub-button mt-4 px-4"
                                        >
                                            {loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
                                            {!loading && (pageId ? "Update" : "Submit")}
                                        </button>
                                    </div>
                                </Form>
                            )
                        )}
                    </Formik>
                    <form className="mg-login new-product mt-4 px-3"></form>
                </div>
            </div>
        </>
    );
}

export default NewPageForm;